import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

import AutosubmitController from "./controllers/autosubmit_controller"
import BasketController from "./controllers/basket_controller"
import ClipboardUploadController from "./controllers/clipboard_upload_controller"
import CountdownController from "./controllers/countdown_controller"
import FlashController from "./controllers/flash_controller"
import FocusQuantityController from "./controllers/focus_quantity_controller"
import IdCheckController from "./controllers/id_check_controller"
import InstallController from "./controllers/install_controller"
import ModalController from "./controllers/modal_controller"
import NoticeDismissController from "./controllers/notice_dismiss_controller"

const application = Application.start()
application.debug = false

application.register("autosubmit", AutosubmitController)
application.register("basket", BasketController)
application.register("clipboard-upload", ClipboardUploadController)
application.register("countdown", CountdownController)
application.register("flash", FlashController)
application.register("focus-quantity", FocusQuantityController)
application.register("id-check", IdCheckController)
application.register("install", InstallController)
application.register("modal", ModalController)
application.register("notice-dismiss", NoticeDismissController)

declare global {
  interface Window { Stimulus: Application }
}
window.Stimulus = application

// 바탕화면 설치(PWA)를 위한 서비스워커 등록.
//
// 크롬 계열은 "fetch 핸들러가 있는 서비스워커 + 매니페스트 + HTTPS" 가 모두
// 갖춰져야 beforeinstallprompt 를 준다. 등록하지 않으면 설치 버튼이 영영 뜨지 않는다.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker", { scope: "/" }).catch((error) => {
      console.warn("서비스워커 등록 실패:", error)
    })
  })
}

export { application }
